import { memo } from "react";

import TableSkeletonRow from "./Row";

type TableSkeletonProps = {
  rowsPerPage: number;
  columnIds: string[];
};

const TableSkeleton = memo(({ rowsPerPage, columnIds }: TableSkeletonProps) => {
  return (
    <div style={{ display: "table-row-group" }} role="rowgroup">
      {Array.from({ length: rowsPerPage }).map((_, i) => (
        <TableSkeletonRow columnIds={columnIds} key={i} />
      ))}
    </div>
  );
});

TableSkeleton.displayName = "DS.Table.Skeleton";

export default TableSkeleton;
